export function ProductStockTakeCtrl (
  $scope,
  $translate,
  tableApi,
  workshopAPI
) {
  $scope.showStockTakeLog = !!$scope.log.length;
  $scope.tableCacheKey    = 'productStockTake';

  $scope.tableSettings = {
    cache: {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        field : 'post_date',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.POST_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'old_quantity',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.OLD_QUANTITY')
        }
      },
      {
        field : 'new_quantity',
        header: {
          text: $translate.instant('JS_SPACE.COLUMNS.NEW_QUANTITY')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.LOG_IS_EMPTY')
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/stock_take_logs/count', $scope.product.id)
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    }
  };

  $scope.getLogs = ( params ) => {
    return workshopAPI.get('/stock_take_logs', [
      $scope.product.id,
      params.offset,
      params.pageSize
    ]).then(log => {
      $scope.log = log;

      return log;
    });
  };
};